import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { Link } from "react-router-dom";
import { fetchRteTransactions } from "../../api/RTETransaction";

const STATUS_MAP = {
  // 0: { label: "Cancelled", class: "bg-label-secondary" },
  1: { label: "Success", class: "bg-label-success" },
  2: { label: "Pending", class: "bg-label-warning" },
  3: { label: "Failed", class: "bg-label-danger" },
  // 4: { label: "Refunded", class: "bg-label-info" },
};

export default function RTETransaction() {
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  });

  const [filters, setFilters] = useState({
    status: "",
    payment_method: "",
    from_date: "",
    to_date: "",
    search: "",
  });

  const fetchTransactions = async (page = 1, filtersOverride = null) => {
    setLoading(true);
    try {
      const activeFilters = filtersOverride || filters;
      const params = {
        page,
        per_page: pagination.per_page,
        ...(activeFilters.status && { status: activeFilters.status }),
        ...(activeFilters.payment_method && {
          payment_method: activeFilters.payment_method,
        }),
        ...(activeFilters.from_date && { from_date: activeFilters.from_date }),
        ...(activeFilters.to_date && { to_date: activeFilters.to_date }),
        ...(activeFilters.search && { search: activeFilters.search }),
      };

      const queryString = new URLSearchParams(params).toString();

      const res = await fetchRteTransactions(queryString);

      if (res.data.status) {
        setTransactions(res.data.data.data);
        setPagination({
          current_page: res.data.data.current_page,
          last_page: res.data.data.last_page,
          per_page: res.data.data.per_page,
          total: res.data.data.total,
        });
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        error?.response?.data?.message || "Failed to fetch RTE transactions",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    fetchTransactions(1);
  };

  const resetFilters = () => {
    const emptyFilters = {
      status: "",
      payment_method: "",
      from_date: "",
      to_date: "",
      search: "",
    };
    setFilters(emptyFilters);
    fetchTransactions(1, emptyFilters);
  };

  const goToPage = (page) => {
    if (page < 1 || page > pagination.last_page) return;
    fetchTransactions(page);
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                          <div>
                            <h3 className="fw-bold mb-1">RTE Transactions</h3>
                            <div className="text-body-secondary">
                              {pagination.total} record
                              {pagination.total !== 1 ? "s" : ""} found
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <Link
                              to="/students/rte"
                              className="btn btn-outline-primary"
                            >
                              <i className="ri-arrow-left-line me-1"></i>
                              Back
                            </Link>
                          </div>
                        </div>

                        {/* Filters */}
                        <div className="row g-3 mb-4">
                          <div className="col-md-3">
                            <label className="form-label">Search</label>
                            <input
                              type="text"
                              name="search"
                              className="form-control"
                              placeholder="Receipt / Transaction No"
                              value={filters.search}
                              onChange={handleFilterChange}
                            />
                          </div>

                          <div className="col-md-2">
                            <label className="form-label">Status</label>
                            <select
                              name="status"
                              className="form-select"
                              value={filters.status}
                              onChange={handleFilterChange}
                            >
                              <option value="">All</option>
                              <option value="1">Success</option>
                              <option value="2">Pending</option>
                              {/* <option value="0">Cancelled</option> */}
                              <option value="3">Failed</option>
                              {/* <option value="4">Refunded</option> */}
                            </select>
                          </div>

                          <div className="col-md-2">
                            <label className="form-label">Payment Method</label>
                            <select
                              name="payment_method"
                              className="form-select"
                              value={filters.payment_method}
                              onChange={handleFilterChange}
                            >
                              <option value="">All</option>
                              <option value="Cash">Cash</option>
                              <option value="Online">Online</option>
                            </select>
                          </div>

                          <div className="col-md-2">
                            <label className="form-label">From Date</label>
                            <input
                              type="date"
                              name="from_date"
                              className="form-control"
                              value={filters.from_date}
                              onChange={handleFilterChange}
                            />
                          </div>

                          <div className="col-md-2">
                            <label className="form-label">To Date</label>
                            <input
                              type="date"
                              name="to_date"
                              className="form-control"
                              value={filters.to_date}
                              onChange={handleFilterChange}
                            />
                          </div>

                          <div className="col-md-1 d-flex align-items-end gap-2">
                            <button
                              className="btn btn-primary w-100"
                              onClick={applyFilters}
                              title="Apply Filters"
                            >
                              <i className="ri-search-line"></i>
                            </button>
                          </div>
                        </div>

                        <div className="d-flex justify-content-end mb-3">
                          <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={resetFilters}
                          >
                            <i className="ri-refresh-line me-1"></i>
                            Reset Filters
                          </button>
                        </div>

                        {/* Table */}
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Receipt No</th>
                                <th>Amount</th>
                                <th>Payment Method</th>
                                <th>Transaction No</th>
                                <th>Payment Date</th>
                                <th>Status</th>
                                <th>Bill</th>
                                <th>Remark</th>
                              </tr>
                            </thead>
                            <tbody>
                              {transactions.length === 0 ? (
                                <tr>
                                  <td colSpan="9" className="text-center py-4">
                                    No RTE transactions found
                                  </td>
                                </tr>
                              ) : (
                                transactions.map((txn, index) => (
                                  <tr key={txn.id}>
                                    <td>
                                      {(pagination.current_page - 1) *
                                        pagination.per_page +
                                        index +
                                        1}
                                    </td>
                                    <td>{txn.receipt_no || "-"}</td>
                                    <td>₹{Number(txn.amount).toFixed(2)}</td>
                                    <td>{txn.payment_method}</td>
                                    <td>{txn.transaction_no || "-"}</td>
                                    <td>{txn.payment_date || "-"}</td>
                                    <td>
                                      <span
                                        className={`badge ${
                                          STATUS_MAP[txn.status]?.class ||
                                          "bg-label-secondary"
                                        }`}
                                      >
                                        {STATUS_MAP[txn.status]?.label ||
                                          "Unknown"}
                                      </span>
                                    </td>
                                    <td>
                                      {txn.image ? (
                                        <a
                                          href={txn.image}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-sm btn-outline-primary"
                                        >
                                          <i className="ri-file-line"></i> View
                                        </a>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td>{txn.remark || "-"}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        {pagination.last_page > 1 && (
                          <nav className="d-flex justify-content-end mt-3">
                            <ul className="pagination mb-0">
                              <li
                                className={`page-item ${
                                  pagination.current_page === 1
                                    ? "disabled"
                                    : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() =>
                                    goToPage(pagination.current_page - 1)
                                  }
                                >
                                  Previous
                                </button>
                              </li>
                              {Array.from(
                                { length: pagination.last_page },
                                (_, i) => i + 1,
                              ).map((page) => (
                                <li
                                  key={page}
                                  className={`page-item ${
                                    page === pagination.current_page
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => goToPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              ))}
                              <li
                                className={`page-item ${
                                  pagination.current_page ===
                                  pagination.last_page
                                    ? "disabled"
                                    : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() =>
                                    goToPage(pagination.current_page + 1)
                                  }
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
